// extracted by mini-css-extract-plugin
export default {"repairTable":"RepairTable_repairTable__Hs1QN","table":"RepairTable_table__fSTtm","nameCell":"RepairTable_nameCell__pLwB+","centerCell":"RepairTable_centerCell__O88nx"};